<template>
  <div style="margin-bottom: 140px" class="flex flex-wrap mb-4">
    <div class="w-full" :class="hideSidebar ? 'md:w-1/4' : 'md:w-1/3'"></div>
    <div class="w-full" :class="hideSidebar ? 'md:w-2/4' : 'md:w-1/3'">
      <h1 class="mb-6 text-center big-title">
        {{ title }}
      </h1>
      <h2 v-if="subTitle" class="mb-6 text-center f-m">
        {{ subTitle }}
      </h2>
      <img class="reg-completed-img" :src="image" />
      <p v-if="subText" class="mb-5">{{ subText }}</p>

      <div class="info-box">
        <p v-if="boldText" class="f-b">{{ boldText }}</p>
        <p v-if="infoText" class="">{{ infoText }}</p>
        <ul class="text-grey">
          <li v-for="element in dotsList" :key="element" class="mb-2">
            {{ element }}
          </li>
        </ul>
        <p v-if="bottomText" class="mt-5">{{ bottomText }}</p>
      </div>
    </div>
    <div class="w-full" :class="hideSidebar ? 'md:w-1/4' : 'md:w-1/3'">
      <div class="info-card-box" v-if="!hideSidebar">
        <div class="card">
          <div class="card__box md:w-1/2 m-center p-5 rounded">
            <img v-if="cardImage" class="card-img shadow-lg" :src="cardImage" />
            <p v-if="sidebarTitle" class="f-b mt-10 mb-3">
              {{ sidebarTitle }}
            </p>
            <p v-if="sidebarHTML" class="text-grey" v-html="sidebarHTML"></p>


              <div class="pay-methods mt-3">
                <div class="applePay"></div>
                <div class="samsungPay"></div>
                <div class="googlePay"></div>
              </div>

              <div class="pay-methods">
                <div class="garminPay"></div>
                <div class="fitbitPay"></div>
                <div class="swatchPay"></div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinalPageModule",
  props: [
    "title",
    "subTitle",
    "image",
    "dotsList",
    "cardImage",
    "subText",
    "boldText",
    "infoText",
    "bottomText",
    "hideSidebar",
    "sidebarTitle",
    "sidebarHTML"
  ]
};
</script>
<style lang="less" scoped>
.reg-completed-img {
  width: 150px;
  margin: 20px auto 40px;
}
.info-box {
  text-align: left;
  p {
    margin-bottom: 22px;
  }
  ul {
    margin-left: 20px;
    list-style: initial;
  }
}
.info-card-box {
  margin-top: 60px;
  display: flex;
  height: 100%;
  align-items: center;
  text-align: left;
  .card {
    position: relative;
    .card__box {
      width: 300px;
      img {
        width: 200px;
        position: absolute;
        top: -90px;
        margin-left: 32px;
      }
    }
  }
}
.pay-methods {
    display: flex;
    justify-content: space-around;
    div {
      width: 50px;
      height: 50px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;

      &.applePay {
        background-image: url("../assets/images/payment_logos/applePay_top.png");
      }
      &.samsungPay {
        background-image: url("../assets/images/payment_logos/samsung_pay_badge.png");
      }
      &.garminPay {
        background-image: url("../assets/images/payment_logos/garminPay_top.jpg");
      }
      &.googlePay {
        background-image: url("../assets/images/payment_logos/googlePay_top.jpg");
      }
      &.fitbitPay {
        background-image: url("../assets/images/payment_logos/fitbitPay_top.png");
      }
      &.swatchPay {
        background-image: url("../assets/images/payment_logos/swatchPay.png");
      }

      //mobile sizes
      @media (max-width: 768px) {
        &.applePay {
          width: 56px;
        }

        &.garminPay {
          width: 82px;
        }
        &.googlePay {
          width: 64px;
        }
        &.fitbitPay {
          width: 93px;
        }
        &.swatchPay {
          width: 60px;
          margin-left: 10px;
        }
      }
    }
  }
</style>
